
import { Options, Vue } from 'vue-class-component'
import { useStore } from '@/store'
import { StepEditMobile } from '@/model/step-edit-mobile.model'
import * as otpService from '@/services/line-web-loyalty-bff/v1/otp'
import { alertMessageOptionsOtherCaseError } from '@/model/alert-options.model'
import AlertMessage from '../../../alert-message/alert-message.vue'
import {
  modalOptionsExceededRateLimit,
  modalOptionsTooManyRequest,
  modalTokenExpired,
} from '@/model/modal-options.model'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {
    AlertMessage,
  },
  computed: {
    isModalClose() {
      return this.$store.state.modalEditMobile.isModalClose
    },
    isAlertMessageActive() {
      return this.$store.state.alertMessage.isAlertMessageActive
    },
    isLoadingSpinner() {
      return this.$store.state.modalEditProfile.isLoadingSpinner
    },
  },
})
export default class SelectOption extends Vue {
  @Prop() mobileNumber!: string

  private store = useStore()

  handleUnexpectedError() {
    this.store.dispatch('alertMessage/onOpen', alertMessageOptionsOtherCaseError)
    setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
  }

  async onStepOtp() {
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    const token = this.store.state.lineInfo.idToken
    const mobile = this.store.state.customer.phoneNumber

    try {
      if (token && mobile) {
        const result = await otpService.sendOtp(token, {
          mobile_no: mobile,
        })
        const statusCode = result?.json?.code

        if (statusCode === 200) {
          const { ref_code: refCode } = result?.json?.data
          this.store.commit('modalEditMobile/updateOtpRefCode', refCode)
          this.store.commit('modalEditMobile/updateStep', StepEditMobile.OTP_VERIFICATION)
        } else if (statusCode === 401) {
          const { error_name: errorName } = result?.json?.error
          if (errorName === 'token_expired') {
            this.store.dispatch(
              'modalNotification/onOpenTokenExpired',
              modalTokenExpired(() => {
                this.store.dispatch('modalEditMobile/onResetStep')
                this.store.dispatch('modalEditMobile/onOpen')
                this.store.dispatch('modalNotification/onCloseTokenExpired')
              })
            )
          } else {
            this.handleUnexpectedError()
          }
        } else if (statusCode === 429) {
          const { error_name: errorName } = result?.json?.error
          if (errorName === 'exceeded_rate_limit') {
            this.store.dispatch(
              'modalNotification/onOpen',
              modalOptionsExceededRateLimit(this.store, true)
            )
          } else if (errorName === 'too_many_requests_error') {
            this.store.dispatch('modalNotification/onOpen', modalOptionsTooManyRequest(this.store))
          } else {
            this.handleUnexpectedError()
          }
        } else {
          this.handleUnexpectedError()
        }
        this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
      }
    } catch {
      this.store.dispatch('alertMessage/onOpen', alertMessageOptionsOtherCaseError)
      setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
      this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
    }
  }

  onStepDopa() {
    this.store.commit('modalEditMobile/updateStep', StepEditMobile.DOPA_VERIFICATION)
  }
}
